import React, { useEffect, useMemo, useRef, useState } from "react";
import useDeviceType from "../../hook/useDeviceType";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import FloatButton from "../floatButton/floatButton";
import { Box, Container, Flex, useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import MenuBar from "../Menu/MenuBar";
import {
  defaultGameStatus,
  playedGameStatus,
  playingGameStatus,
} from "../../redux/action/member/memberAction";
import { COMMON_WEB_PATH, WEB_LAYOUT } from "../../constant";
import Header from "./Header";
import Footer from "./Footer";
import useIsLandScape from "../../hook/useIsLandScape";
import useCheckLogin from "../../hook/useCheckLogin";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";
import useLongMachineSetting from "../../hook/useLongMachineSetting";
import HeaderBottom from "./HeaderBottom";

const rank = [
  {
    label: "platform",
  },
  {
    label: "player",
  },
  {
    label: "bet",
  },
];

const isCredit = process.env.REACT_APP_CREDIT == 1;

const Wrapper = ({ children, scrollToTop }) => {
  const { t } = useTranslation();
  const i18n_ranking = (key) => t(`ranking.${key}`);

  const isStickyLeft = useSelector((state) => state.isStickyLeft);
  const gameBoxStatus = useSelector((state) => state.isGameBoxStatus);
  const dispatch = useDispatch();

  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const deviceType = useDeviceType();
  const scrollContainerRef = useRef(null);

  const menuBg = useColorModeValue("light.100", "dark.100");
  const menuBorder = useColorModeValue("gray.300", "dark.100");
  const boxBg = useColorModeValue(
    "linear(to-bl,#F3F6FE,#F3F6FE,#FCE5FE)",
    "linear(to-bl,#1A2036,#1A2036,#1A2036)",
  );
  const mainBg = useColorModeValue("transparent", "#262D47");

  const location = useLocation();

  const navigate = useNavigate();

  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const isMobile = deviceType === "Mobile";
  const isMobileAndLandScape = useIsLandScape({ isMobile: true });

  useEffect(() => {
    if (scrollContainerRef.current && scrollToTop) {
      setTimeout(() => {
        scrollContainerRef.current?.scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
        scrollContainerRef.current?.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 1000) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const { pathname } = location;
  useEffect(() => {
    if (pathname.includes("gamebox")) {
      dispatch(playingGameStatus());
      return;
    }

    if (gameBoxStatus === "playing") {
      dispatch(playedGameStatus());
      dispatch({ type: "GET_BALANCE" });
      setTimeout(() => {
        dispatch(defaultGameStatus());
      }, 1500);
    }
  }, [pathname, gameBoxStatus]);

  const isLandScapeMachine = useIsLandScapeMachine();
  const { longMachineVideoHeight } = useLongMachineSetting();

  return (
    <Box
      overflow={{
        base: "",
        md: "scroll",
        lg: "hidden",
      }}
      className="md:overflow-x-scroll lg:overflow-hidden"
      //bgGradient={boxBg}
    >
      <Container
        px={{
          base: "0px",
        }}
        maxW="100%"
      >
        {isGameBox && isMobile ? null : (
          <>
            {isLandScapeMachine ? (
              <>
                <Box
                  bgImage={`url(${COMMON_WEB_PATH}/now888/header/long_machine_demo_banner.png)`}
                  bgSize="100%100%"
                  bgPosition="center"
                  bgRepeat="no-repeat"
                  h={longMachineVideoHeight}
                  w="100%"
                  mb="10px"
                >
                  <Box
                    as="iframe"
                    w="100%"
                    h="100%"
                    title="ad"
                    src="https://slotparty.co/tv/index.html?lang=id"
                    border="none"
                  ></Box>
                </Box>
                <HeaderBottom />
              </>
            ) : (
              <>
                <Header />
                <Box
                  height={{
                    base: isGameBox ? "0px" : "60px",
                    sm: "60px",
                    md: "100px",
                    xl: isMachineUser ? "150px" : "100px",
                  }}
                />
              </>
            )}
          </>
        )}
        {isGameBox && (
          <Box position="relative">
            <Box
              display={{ base: "none", md: "block" }}
              className="gamebox-bg min-w-screen"
              // style={{
              //   backgroundImage: `url(https://cdnimages3.gcdn.co/HRJLWPLB/images/SC/Leonbets/egs/LeonRoulette2@1920x1080.jpg)`,
              // }}
            ></Box>
            <Box
              display={{ base: "none", md: "block" }}
              // className="gamebox-gradient"
            ></Box>
          </Box>
        )}
        <Flex
          pt={{
            base: isMobileAndLandScape && isGameBox ? "0px" : "5px",
            lg: isMobileAndLandScape && isGameBox ? "0px" : "0px",
          }}
          maxH={{
            xl: isLandScapeMachine
              ? `calc(100dvh - ${longMachineVideoHeight})`
              : isMachineDomain || isMachineUser
                ? "calc(100dvh - 150px)"
                : "calc(100dvh - 100px)",
          }}
        >
          {/* {isGameBox && deviceType === "PC" ? null : (
            <Box
              maxW={`325px`}
              w={{
                base: "0px",
                xl: "100%",
              }}
              overflowX={`hidden`}
              bgSize="cover"
              bgPos="center"
              bgRepeat={`no-repeat`}
              // className="wrapper-menu-shadow"
              position="relative"
              zIndex={1000}
              pt={{
                base: isGameBox ? "0px" : "",
                sm: "0px",
              }}
            >
              <MenuBar />
            </Box>
          )} */}
          <Box
            // minW={{
            //   base: "0px",
            //   xl: isGameBox ? "100%" : "calc(100% - 250px)",
            // }}
            maxW={{
              base: "100%",
              xl: isGameBox
                ? "100%"
                : isMachineDomain || isMachineUser
                  ? "calc(100%)"
                  : "calc(100%)",
            }}
            flex={1}
            w={`100%`}
            ml={{
              base: "0px",
              xl: `common-x`,
            }}
            mr={{
              base: "0px",
              md: ``,
            }}
            h={{
              base: "auto",
              md: isGameBox
                ? "100dvh"
                : isLandScapeMachine
                  ? `calc(100dvh - ${longMachineVideoHeight})`
                  : "calc( 100dvh - 85px )",

              xl:
                isMachineDomain || isMachineUser
                  ? "calc( 100dvh - 150px )"
                  : "calc( 100dvh - 110px )",
            }}
            bg={{
              base: "transparent",
              sm: "transparent",
            }}
            borderRadius={{
              base: "unset",
              sm: "24px",
            }}
            px={{
              base: "unset",
              xl: isMachineDomain || isMachineUser ? 0 : "20px",
            }}
            mx={{
              base: "unset",
              sm: isMobileAndLandScape || isGameBox ? 0 : "10px",
            }}
            className={`${isMobileAndLandScape && isGameBox ? "!mx-0" : ""}`}
          >
            <Flex justifyContent={`space-between`} h={`100%`}>
              <Box
                h={`100%`}
                display={`flex`}
                w="100%"
                maxW={
                  isGameBox
                    ? {
                        base: "100%",
                        xl: "100%",
                        "2xl": "100%",
                      }
                    : {
                        base: "100%",
                        md: "100%",
                        xl: "100%",
                        "2xl": isCredit ? "100%" : "calc(100%)",
                        // md: "1188px",
                      }
                }
                mx={
                  isGameBox
                    ? {
                        base: "auto",
                      }
                    : {
                        base: "auto",
                        xl: "0px",
                      }
                }
              >
                <Box
                  ref={scrollContainerRef}
                  minW={{
                    base: "0px",
                    lg: "772px",
                    xl: "unset",
                  }}
                  w="100%"
                  overflowY={{
                    base: "",
                    sm: "scroll",
                  }}
                  overflowX={{
                    base: "",
                    lg: "unset",
                  }}
                  className={`${
                    isStickyLeft && "!max-w-[1440px]"
                  } no-scrollbar`}
                  pt={{
                    base: isGameBox ? "0px" : "",
                    sm: "",
                  }}
                >
                  {children}
                </Box>
              </Box>
            </Flex>

            {isGameBox ? null : isMobile && <Footer />}
            <FloatButton />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default Wrapper;
